import { lazy } from 'react';
import { Terms } from 'src/compass/shared/util/terms';
import { ICONS } from '../navigationIcons';

const BasisPage = lazy(() => import('src/compass/pages/utilities/BasisPage'));
const DailyPasswordPage = lazy(() => import('src/compass/pages/utilities/DailyPasswordPage'));
const PipPage = lazy(() => import('src/compass/pages/utilities/PipPage'));
const ProprietaryAccountsPage = lazy(
  () => import('src/compass/pages/utilities/ProprietaryAccountsPage')
);
const PoManagementPage = lazy(() => import('src/compass/pages/utilities/PoManagementPage'));
const FeederIndexSetupPage = lazy(() => import('src/compass/pages/utilities/FeederIndexSetupPage'));
const CustomerMaintenancePage = lazy(() => import('src/compass/pages/utilities/CustomerMaintenancePage'));
const MarginCallsPage = lazy(() => import('src/compass/pages/utilities/MarginCallsPage'));
const ChromePluginAccountEditPage = lazy(() => import('src/compass/pages/utilities/ChromePluginAccountEditPage'));

export const UtilitiesMenu = [
  {
    menuTitle: 'Utilities',
    path: 'utilities',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Basis',
        path: 'basis',
        element: <BasisPage />,
        permission: 'UTILITIES_BASIS',
      },
      {
        title: 'Daily Password',
        path: 'dailypassword',
        element: <DailyPasswordPage />,
        permission: 'DAILY_PWD',
      },
      {
        title: `${Terms.Customer.label} Maintenance`,
        path: Terms.Customer.plural,
        element: <CustomerMaintenancePage />,
        permission: 'ENTITIES',
      },
      {
        title: 'Feeder Index Setup',
        path: 'feederindexsetup',
        element: <FeederIndexSetupPage />,
        permission: 'UTILITIES_FDR_IDX_SETUP',
      },
      {
        title: 'Margin Calls',
        path: 'margincalls',
        element: <MarginCallsPage />,
        permission: 'MARGIN_CALLS',
      },
      {
        title: 'Edit Account Call Group',
        path: 'margincalls/callgroup',
        element: <ChromePluginAccountEditPage />,
        permission: 'MARGIN_CALLS',
        hidden: true,
      },
      {
        title: 'PIP',
        path: 'pip',
        element: <PipPage />,
        permission: 'UTILITIES_PIP',
      },
      {
        title: 'PO Management',
        path: 'pomanagement',
        element: <PoManagementPage />,
        permission: 'UTILITIES_PO_MGT',
      },
      {
        title: 'Proprietary Accounts',
        path: 'proprietaryaccounts',
        element: <ProprietaryAccountsPage />,
        permission: 'UTILITIES_PROPRIETARY',
      },
    ],
  },
];
